import React, { useEffect, useState } from "react";
import "./Admin.css";
import { adminApi } from "../services/api";
import { useNotifications } from "../User/Components/Notification/NotificationProvider";

const AdminNotifications = () => {
  const { pushLocal } = useNotifications();
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [form, setForm] = useState({
    title: "",
    message: "",
    type: "info",
    audience: "all",
    link: "",
  });
  const [saving, setSaving] = useState(false);

  const load = async () => {
    setLoading(true);
    setError("");
    try {
      const res = await adminApi.notifications.list();
      setList(res.data || []);
    } catch (err) {
      setError(err.message || "Failed to load");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  const handleCreate = async (e) => {
    e.preventDefault();
    if (!form.title.trim() || !form.message.trim()) {
      setError("Title and message are required");
      return;
    }
    setSaving(true);
    setError("");
    try {
      await adminApi.notifications.create(form);
      setForm({ title: "", message: "", type: "info", audience: "all", link: "" });
      pushLocal({
        title: "Notification sent",
        message: form.title,
        type: "success",
      });
      await load();
    } catch (err) {
      setError(err.message || "Failed to create");
    } finally {
      setSaving(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Delete this notification?")) return;
    try {
      await adminApi.notifications.remove(id);
      await load();
    } catch (err) {
      setError(err.message || "Delete failed");
    }
  };

  return (
    <div className="admin-notifications-page">
      <div className="admin-panel">
        <div className="admin-panel-head">
          <h2>Send notification</h2>
        </div>
        <form className="admin-notif-form" onSubmit={handleCreate}>
          {error && <p className="admin-error">{error}</p>}
          <div className="admin-field">
            <label>Title</label>
            <input
              value={form.title}
              onChange={(e) => setForm({ ...form, title: e.target.value })}
              required
            />
          </div>
          <div className="admin-field">
            <label>Message</label>
            <textarea
              value={form.message}
              onChange={(e) => setForm({ ...form, message: e.target.value })}
              rows={3}
              required
            />
          </div>
          <div className="admin-form-row">
            <div className="admin-field">
              <label>Type</label>
              <select
                value={form.type}
                onChange={(e) => setForm({ ...form, type: e.target.value })}
              >
                <option value="info">Info</option>
                <option value="success">Success</option>
                <option value="warning">Warning</option>
                <option value="error">Error</option>
              </select>
            </div>
            <div className="admin-field">
              <label>Audience</label>
              <select
                value={form.audience}
                onChange={(e) => setForm({ ...form, audience: e.target.value })}
              >
                <option value="all">All users</option>
                <option value="admin">Admins only</option>
                <option value="user">Users only</option>
              </select>
            </div>
          </div>
          <div className="admin-field">
            <label>Link (optional)</label>
            <input
              value={form.link}
              onChange={(e) => setForm({ ...form, link: e.target.value })}
              placeholder="/cars"
            />
          </div>
          <button type="submit" className="admin-btn admin-btn-primary" disabled={saving}>
            {saving ? "Sending…" : "Send notification"}
          </button>
        </form>
      </div>

      <div className="admin-panel" style={{ marginTop: "1.25rem" }}>
        <div className="admin-panel-head">
          <h2>Sent notifications</h2>
        </div>
        {loading ? (
          <div className="admin-loading">Loading…</div>
        ) : list.length === 0 ? (
          <div className="admin-empty">No notifications sent yet.</div>
        ) : (
          <div className="admin-table-wrap">
            <table className="admin-table">
              <thead>
                <tr>
                  <th>Title</th>
                  <th>Audience</th>
                  <th>Type</th>
                  <th>Date</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {list.map((n) => (
                  <tr key={n._id}>
                    <td>
                      <strong>{n.title}</strong>
                      <br />
                      <small>{n.message}</small>
                    </td>
                    <td>{n.audience}</td>
                    <td>{n.type}</td>
                    <td>{new Date(n.createdAt).toLocaleString()}</td>
                    <td>
                      <button
                        type="button"
                        className="admin-btn admin-btn-danger"
                        onClick={() => handleDelete(n._id)}
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default AdminNotifications;
